module.exports = __webpack_public_path__ + "img/paper3.2eb2d387.png";